<div class="container">
  <app-full-page-spinner *ngIf="loading$ | async"></app-full-page-spinner>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <h2 i18n>Create an Account</h2>
      </div>
    </div>
    <div class="row mt-4" [formGroupName]="Name">
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <app-text-field-input
            [identifier]="FirstName"
            label="First name"
            labelAsterix="true"
            i18n-label
            placeholder="Your first name goes here"
            i18n-placeholder
            [formControlName]="FirstName"
            [autocomplete]="'new-password'"
          >
          </app-text-field-input>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <app-text-field-input
            [identifier]="LastName"
            label="Last name"
            labelAsterix="true"
            i18n-label
            placeholder="Your last name goes here"
            i18n-placeholder
            [formControlName]="LastName"
            [autocomplete]="'new-password'"
          >
          </app-text-field-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h6 class="card-title mb-2" i18n>Preferred Method of Contact</h6>
        <p class="text-muted mb-3" i18n>
          Choose how we’ll contact you. You’ll also use this to log in if you create an account
          after the order is submitted.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input
          class="radio-input"
          type="radio"
          id="contactPhone"
          formControlName="contactMethod"
          value="phone"
          (click)="onContactMethodClick('phone')"
        />
        <label class="label" for="contactPhone" i18n>Mobile Phone #</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input
          class="radio-input"
          type="radio"
          id="contactEmail"
          formControlName="contactMethod"
          (click)="onContactMethodClick('email')"
          value="email"
        />
        <label class="label" for="contactEmail" i18n>Email Address</label>
      </div>
    </div>

    <div>
      <div [hidden]="!isPhoneNumberAdded">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <app-text-field-input
                #phoneNumber
                [identifier]="PhoneNumber"
                label="Mobile number"
                i18n-label
                placeholder="Your phone number goes here"
                i18n-placeholder
                formControlName="phoneNumber"
                type="tel"
                [isDataPrivate]="true"
              >
              </app-text-field-input>
              <div
                *ngIf="(userPrincipalErrorType$ | async) === PhErrorTypes.UserPrincipal"
                class="col-12 validation-error-message mb-2"
              >
                <span id="phone-error-message" i18n>
                  This phone number cannot be used in Ecommerce because it is already registered!
                </span>
              </div>
              <div *ngIf="showPhoneRequiredMessage" class="col-12 validation-error-message mb-2">
                <span id="phone-required-message" i18n>
                  Please enter your mobile phone number to proceed.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div [hidden]="!isEmailAddressAdded">
        <div class="row" formGroupName="email">
          <div class="col-md-6">
            <div class="form-group">
              <app-text-field-input
                #emailInput
                [identifier]="Email"
                type="email"
                label="Email address"
                i18n-label
                placeholder="Your email address goes here"
                i18n-placeholder
                [formControlName]="Email"
                [readonly]="isAuthenticated$ | async"
                [isDataPrivate]="true"
              >
              </app-text-field-input>
              <div *ngIf="showEmailRequiredMessage" class="validation-error-message mt-1">
                <span id="email-required-message" i18n>
                  Please enter your email address to proceed.
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <app-text-field-input
                #emailConfirmInput
                [identifier]="EmailConfirm"
                type="email"
                label="Re-enter email address"
                i18n-label
                [groupValidationErrorType]="FormErrorTypes.emailConfirm"
                placeholder="Your email address goes here"
                i18n-placeholder
                [formControlName]="EmailConfirm"
                [isDataPrivate]="true"
              >
              </app-text-field-input>
              <div *ngIf="showEmailConfirmRequiredMessage" class="validation-error-message mt-1">
                <span id="email-confirm-required-message" i18n>
                  Please re-enter your email address to proceed.
                </span>
              </div>
            </div>
          </div>
          <div
            *ngIf="(emailErrorType$ | async) === PhErrorTypes.Email"
            class="col-12 validation-error-message mb-2"
          >
            <span id="email-error-message" i18n
              >This e-mail cannot be used in Ecommerce because it is already registered on a PH
              consultant!</span
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div *ngIf="!isEmailAddressAdded || !isPhoneNumberAdded">
            <div class="row">
              <div class="col-md-6">
                <button class="btn btn-call" (click)="addContact()" i18n>
                  <img class="icon" src="assets/images/icons/addcontact.svg" /> ADD ANOTHER CONTACT
                  METHOD
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="!isEmailAddressAdded">
      <div class="row mt-3" [formGroupName]="Password">
        <div class="col-sm-12 col-md-6">
          <div class="form-group">
            <app-password-input
              [identifier]="Password"
              label="Password"
              required="true"
              i18n-label
              [formErrorMessages]="ErrorMessages"
              [formControlName]="Password"
            ></app-password-input>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="form-group">
            <app-password-input
              [identifier]="PasswordConfirm"
              label="Re-enter password"
              required="true"
              i18n-label
              [groupValidationErrorType]="FormErrorTypes.passwordConfirm"
              [formControlName]="PasswordConfirm"
            ></app-password-input>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <ng-template *ngTemplateOutlet="passwordStrengthValidationMessage"></ng-template>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <span class="text-asterix mr-1"> </span>
          <span i18n>Required</span>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!((isAuthenticated$ | async) === true)">
      <div class="col">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [formControlName]="Updates"
            id="updates"
          />
          <label i18n class="form-check-label" for="updates">
            Subscribe to receive future updates from Princess House about new products and
            promotions.
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [formControlName]="ShareWithConsultant"
            id="shareWithConsultantChkbox"
          />
          <label class="form-check-label font-size-16 my-1" for="shareWithConsultantChkbox" i18n>
            I’d like my Consultant to have my contact information so they can help me with orders or
            any questions.
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-sm-12 col-md-6">
        <button
          type="submit"
          class="btn btn-lg btn-primary btn-uppercase-lg w-100"
          [disabled]="disableSubmit$ | async"
          i18n
        >
          Create account
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="validation-error-message col-12 mb-2" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <p i18n
          >By creating an account, you agree to the
          <a class="font-weight-bold" [routerLink]="URL.TermsOfUse"
            >Princess House's Terms of Use</a
          >
          and
          <a class="font-weight-bold" [routerLink]="URL.PrivacyPolicy">Privacy Policy</a>
        </p>
      </div>
    </div>
  </form>
</div>

<ng-template #passwordStrengthValidationMessage>
  <p class="p-0 m-0 font-weight-bold text-double-dot" i18n>Password must</p>
  <ul class="mb-0">
    <li i18n>8 or more characters</li>
    <li i18n>Upper & lowercase letters</li>
    <li i18n>At least one number: 0-9</li>
    <li i18n>At least one symbol: {{ '!@#^&()+_,.{}?-' }}</li>
  </ul>
</ng-template>
